import { Injectable, effect, inject, untracked } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { APP_ENVIRONMENT } from '@qtek/core/api-core';
import { UserStore } from '@qtek/libs/store';

@Injectable({ providedIn: 'root' })
export class DatadogRumService {
  private readonly environment = inject(APP_ENVIRONMENT);
  private readonly userStore = inject(UserStore);

  constructor() {
    if (!this.environment.dataDogRumEnabled) return;

    effect(() => {
      const prs = this.userStore.prs();
      const acn = this.userStore.acn();
      if (!prs?.prsId) return;

      untracked(() => {
        datadogRum.setUser({
          id: prs.usrId,
          name: `${prs.fname ?? ''} ${prs.lname ?? ''}`.trim() || prs.name,
          email: prs.email,
          prsId: prs.prsId,
        });

        if (acn?._id) {
          datadogRum.setAccount({
            id: acn._id,
            name: acn.name?.name,
          });
        }
      });
    });
  }
}
